import { webApiWithResponse } from "../../../../core/http/httpThunks";
import { EditOrder } from "../types";

export const createOrderApi = (order: EditOrder) =>
  webApiWithResponse<string>({
    method: "POST",
    url: "order/neworder",
    data: order
  });

export default createOrderApi;
